import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingRoutingModule } from './setting-routing.module';
import { SettingComponent } from './setting.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { PasswordModule } from 'primeng/password';
import { RbacModule } from '../rbac/rbac.module';
import { DataSourceComponent } from './data-source/data-source.component';
import { PlatformSettingsComponent } from './platform-settings/platform-settings.component';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { GridListModule } from '@app/shared/modules/grid-list/grid-list.module';
// import { GlobalSearchComponent } from './global-search/global-search.component';


@NgModule({
  declarations: [SettingComponent, DataSourceComponent, PlatformSettingsComponent],
  imports: [
    CommonModule,
    SettingRoutingModule,
    TabMenuModule,
    ContextMenuModule,
    DxDataGridModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    InputMaskModule,
    InputNumberModule,
    PasswordModule,
    RbacModule,
    CardModule,
    DropdownModule,
    GridListModule,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingModule {}
